import { deserialise } from "kitsu-core";

import { ApiKey } from "../ApiKey";
import { FetchConfig } from "../FetchConfig";
import { FetchAdapter } from "../FetchAdapter/FetchAdapter";
import { BugsnagAdapter } from "../BugsnagAdapter/BugsnagAdapter";
import { VidioApi } from "shared/vidio_helpers";
import Cookies from 'js-cookie';

class JsonApiAdapter {
  static async fetchApi(path, options = {}) {
    const config = await JsonApiAdapter.getApiHeaders(options);
    const url = JsonApiAdapter.generateUrl(path);

    return FetchAdapter.get(url, config)
      .then((response) => {
        if (response.status === 204) {
          return { data: [] };
        } else {
          return deserialise(response.json());
        }
      })
      .catch((e) => {
        const err = e instanceof Error ? e : new Error(` is aborted`);
        BugsnagAdapter.notify("JsonApiAdapter::fetchApi", err, e);

        return { data: [] };
      });
  }

  static async rawFetchApi(path, options = {}) {
    const config = await JsonApiAdapter.getApiHeaders(options);
    const url = JsonApiAdapter.generateUrl(path);

    return FetchAdapter.rawFetch(url, config);
  }

  static async getApiHeaders(options = {}) {
    const header = {
      "X-API-KEY": await ApiKey.getToken(),
      "Content-Type": "application/vnd.api+json",
      "Accept-Language": Cookies.get('locale'),
    };

    return new FetchConfig(options).attachHeaders(header);
  }

  static generateUrl(url) {
    try {
      new URL(url);
      return url;
    } catch (e) {
      return VidioApi.generateUrl(url);
    }
  }
}

export { JsonApiAdapter };
